(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rg-global-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('RGGlobalLocalization');
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    const currentLanguage = root.dataset.currentLanguage;
    const currentCountry = root.dataset.currentCountry;
    const preferenceKey = 'rg_locale_preference';
    const form = root.querySelector('#RGDetectedLocalizationForm');
    const countryInput = root.querySelector('[data-rg-country]');
    const languageInput = root.querySelector('[data-rg-language]');
    const message = root.querySelector('[data-rg-localization-message]');
    const accept = root.querySelector('[data-rg-localization-accept]');
    const dismiss = root.querySelector('[data-rg-localization-dismiss]');

    document.querySelectorAll('form[action*="/localization"]').forEach((localizationForm) => {
      localizationForm.addEventListener('submit', () => {
        const language = localizationForm.querySelector('[name="language_code"]')?.value;
        if (language) localStorage.setItem(preferenceKey, language);
      });
    });

    if (currentLanguage !== 'es' || localStorage.getItem(preferenceKey)) return;

    const base = window.Shopify?.routes?.root || '/';
    const url =
      base +
      'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(currentCountry);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Localization detection unavailable');
        return response.json();
      })
      .then((data) => {
        const detectedCountry =
          data?.detected_values?.country?.handle ||
          data?.suggestions?.[0]?.parts?.country?.handle;
        const detectedName =
          data?.detected_values?.country?.name ||
          data?.suggestions?.[0]?.parts?.country?.name ||
          detectedCountry;

        if (!detectedCountry || detectedCountry === 'ES') return;

        message.textContent = root.dataset.prompt.replace('[country]', detectedName);
        root.hidden = false;

        accept.addEventListener(
          'click',
          () => {
            countryInput.value = detectedCountry;
            languageInput.value = 'en';
            localStorage.setItem(preferenceKey, 'en');
            form.submit();
          },
          { once: true }
        );

        dismiss.addEventListener(
          'click',
          () => {
            localStorage.setItem(preferenceKey, 'es');
            root.hidden = true;
          },
          { once: true }
        );
      })
      .catch(() => {
        root.hidden = true;
      });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rg-language-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-rg-language-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      localStorage.setItem('rg_locale_preference', button.dataset.rgLanguageChoice);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
